export default "__VITE_PUBLIC_ASSET__b7ee6b38__"